/**
 *
 * @module AuthCookieProvider
 *
 */

import Check from 'check-types';
import Services from './../services/entry';
import MediaManager from './mediaManager';

const Util = Services.Util;
const AccessToken = Services.Token.AccessToken;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class AuthCookieProvider
 * @since 3.1.0
 * @desc Defines the contract for providing a key required for decrypting media.
 * @note Facade for {SDK.Media.MediaManager}
 *
 */
export default class AuthCookieProvider {

    /**
     *
     * @param {MediaManager} provider
     *
     */
    constructor(provider) {

        const errorMessage = {
            ctor: 'AuthCookieProvider(provider)',
            get provider() {
                return `${this.ctor} needs SDK.Media.MediaManager instance`;
            }
        };

        instanceStrict(provider, MediaManager, errorMessage.provider, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {MediaManager}
         *
         */
        this.provider = provider;

    }

    /**
     *
     * @access public
     * @param {SDK.Services.Token.AccessToken} accessToken  - The current access token.
     * @desc Gets the current encryption key in the form of a cookie via the key service.
     * @returns {Promise<Void>}
     *
     */
    createCookie(accessToken) {

        const errorMessage = {
            method: 'AuthCookieProvider.createCookie(accessToken)',
            get accessToken() {
                return `${this.method} needs AccessToken instance`;
            }
        };

        instanceStrict(accessToken, AccessToken, errorMessage.accessToken, InvalidArgumentException);

        const { provider } = this;
        const cookieEnabled = Util.getSafe(() => provider.config.extras.cookieEnabled);

        if (cookieEnabled) {

            return provider.createAuthCookie(accessToken);

        }

        return Promise.resolve();

    }

}



// WEBPACK FOOTER //
// ./src/media/authCookieProvider.js